<template>
    <div class="uxo-list">
        <template v-if="terroristGroups.length">
            <div v-for="(tg) in terroristGroups" class="column is-4-mobile is-4-tablet is-3-desktop mb-2 mb-md-4">
                <a class="uxo-list__item" :href="terroristGroupUrl(tg)">
                    <div
                        v-if="tg.images.length > 0"
                        class="uxo-list__item-image-placeholder uxo-list__item-image-placeholder--16x4 border-radius"
                        :style="{'background-image' : `url('${tg.images[0].aws_url}')`}">
                        <img class="image mb-1 d-hidden" :src="tg.images[0] ? tg.images[0].aws_url: ''" :alt="tg.name"/>
                    </div>
                    <div v-else class="uxo-list__item-image-placeholder uxo-list__item-image-placeholder--16x4 border-radius"></div>
                    <h5 class="uxo-list__item-title">{{ tg.name }}</h5>
                </a>
            </div>
        </template>
        <template v-else>
            <div class="empty-search column text-center py-4 py-md-10">
                <h1 class="empty-search__title mb-3">Unfortunately, there are not any results matching your
                    criteria</h1>
            </div>
        </template>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: 'CatUxoTerroristGroups',
        methods: {
            toggleBodyClass() {
                let body = document.body;
                body.classList.add('has-overlay');
            },
            terroristGroupUrl(tg) {
                return `/explosive-hazards/terrorist-groups/${tg.slug}`;
            }
        },
        computed: {
            ...mapState('terroristGroups', [
                'terroristGroups',
            ]),
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    @media(max-width: 480px) {
        .column {
            width: 50%;
        }
    }

    @media(min-width: 768px) {
        .column.is-full {
            display: none;
        }
    }

    @media (max-width: 560px) {
        .column.is-4-mobile {
            width: 50%;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/uxo/TerroristGroups.vue